import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import Women from "../components/women";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: "50vh",
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
    },
  },
  next: {
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
  back: {
    y: "+100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
};

const Slide1 = ({ screen }) => {
  const [exit, setExit] = useState("next");
  return (
    <motion.div
      className="about-container"
      variants={containerVariants}
      initial="hidden"
      animate="show"
      exit={exit}
    >
      <div
        style={{
          height: "100vh",
          width: "80%",
          margin: "auto",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} style={{ padding: 0 }}>
            <div style={{ textAlign: screen > 600 ? "left" : "center" }}>
              <motion.h1
                initial={{ y: 10 }}
                animate={{
                  y: -10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
                onClick={() => {
                  setExit("back");
                }}
              >
                <Link className="link" to="/">
                  &#8657;
                </Link>
              </motion.h1>
            </div>
            <div
              style={{
                display: screen > 600 ? "grid" : "inline-block",
                alignItems: "center",
                minHeight: "70vh",
                width: "100%",
                zIndex: -1,
              }}
              data-aos="fade-up"
              data-aos-offset="500"
            >
              <div
                style={{
                  color: "white",
                  fontSize: screen > 600 ? "5rem" : "3rem",
                  lineHeight: "3rem",
                  fontFamily: "Champagne",
                  textAlign: screen > 600 ? "left" : "center",
                  width: "100%",
                }}
              >
                Ella es <span style={{ color: "#77b516" }}>DIANA</span>
              </div>
            </div>
            <div style={{ textAlign: screen > 600 ? "left" : "center" }}>
              <motion.h1
                initial={{ y: -10 }}
                animate={{
                  y: 10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
              >
                <Link className="link" to="/slide2">
                  &#8659;
                </Link>
              </motion.h1>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ padding: 0, zIndex: screen > 600 ? 2 : -1 }}
          >
            <Women screen={screen} />
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
};

export default Slide1;
